export default "__VITE_ASSET__vBmN8BAI__"